module.exports = __webpack_public_path__ + "img/72a7a57.png";